// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"header_disable-scroll__HULTo"};